import React from "react";

const HistoryOne = () => {
  return (
    <>
      {/* history area start */}
      <section className="history__area-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="digibold-section-wrapper-5"
                data-aos="fade-up"
                data-aos-delay={300}
              >
                <h2 className="section-subtitle-5 heading-animation">
                  OUR HISTORY
                </h2>
                <h3 className="section-title-5 heading-animation">
                  Transforming your business <br /> with technology
                </h3>
              </div>
              <div className="history__content-5">
                <div className="history__items-5">
                  <div
                    className="history__item-5"
                    data-aos="fade-up"
                    data-aos-delay={200}
                  >
                    <img
                      className="double-chevron"
                      src="assets/imgs/home-5/chevron-right.png"
                      alt="chevron right"
                    />
                    <h2 className="title">1980</h2>
                    <h3 className="title-2">UI/UX Design</h3>
                    <p>
                      It is a long established fact that a reader jk will be
                      distracted by the desi readable contentk layout.
                    </p>
                  </div>
                  <div
                    className="history__item-5"
                    data-aos="fade-up"
                    data-aos-delay={300}
                  >
                    <img
                      className="double-chevron"
                      src="assets/imgs/home-5/chevron-right.png"
                      alt="chevron right"
                    />
                    <h2 className="title">1990</h2>
                    <h3 className="title-2">Creative digital</h3>
                    <p>
                      It is a long established fact that a reader jk will be
                      distracted by the desi readable contentk layout.
                    </p>
                  </div>
                  <div
                    className="history__item-5"
                    data-aos="fade-up"
                    data-aos-delay={400}
                  >
                    <img
                      className="double-chevron"
                      src="assets/imgs/home-5/chevron-right.png"
                      alt="chevron right"
                    />
                    <h2 className="title">2000</h2>
                    <h3 className="title-2">Agency Solutions</h3>
                    <p>
                      It is a long established fact that a reader jk will be
                      distracted by the desi readable contentk layout.
                    </p>
                  </div>
                  <div
                    className="history__item-5"
                    data-aos="fade-up"
                    data-aos-delay={500}
                  >
                    <img
                      className="double-chevron"
                      src="assets/imgs/home-5/chevron-right.png"
                      alt="chevron right"
                    />
                    <h2 className="title">2022</h2>
                    <h3 className="title-2">Business Solutions</h3>
                    <p>
                      It is a long established fact that a reader jk will be
                      distracted by the desi readable contentk layout.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="history__thumb-5"
                data-aos="fade-up"
                data-aos-delay={300}
              >
                <img
                  src="assets/imgs/home-5/history.png"
                  alt="history "
                  data-lag="0.3"
                />
                <div className="history__circle-btn-wrapper">
                  <div className="history__circle-btn">
                    <h2 className="title">99k+</h2>
                    <p>Clients</p>
                  </div>
                </div>
                <div className="history__box-wrapper">
                  <div className="history__box-5">
                    <h2 className="title">FROM</h2>
                    <h3 className="title-2">1990</h3>
                  </div>
                </div>
                <img
                  className="history-shape-5"
                  src="assets/imgs/home-5/history-shape.png"
                  alt="hero shape"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* history area end */}
    </>
  );
};

export default HistoryOne;
